import api from "./api";
import History from "@/model/history";

class HistoryApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async index() {
    const response = await this.getHttp().get<any>('histories');
    const histories = response.data.data.orders;
    const result = []

    histories.map(item => {
      result.push(item)
    })

    return result.map(item => {
      return new History(item)
    })
  }
}

export default new HistoryApi();
